<template>
  <v-menu offset-y>
    <template #activator="{ props }">
      <v-btn
          v-bind="props"
          class="ma-2 pa-2"
          color="primary"
          aria-label="More actions"
          >
          <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>

    <v-list>
      <!-- Create purchase -->
      <v-list-item
          :disabled="actions_disabled"
          @click="$emit('createPBtn')"
          >
          <template #prepend>
            <v-icon class="mr-2">mdi-cart-outline</v-icon>
          </template>
          <v-list-item-title>
            {{ $filters.capitalize($t('purchase_view.actions.create')) }}
          </v-list-item-title>
      </v-list-item>

      <!-- Add purchase line -->
      <v-list-item @click="$emit('createPLBtn')">
        <template #prepend>
          <v-icon class="mr-2">mdi-cart-plus</v-icon>
        </template>
        <v-list-item-title>
          {{ $filters.capitalize($t('purchase_view.actions.add_line')) }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
  export default {
    name: 'PurchaseActions',
    props: {
      actions_disabled: {type: Boolean, default: false },
    },
    emits: [
      "createPBtn",
      "createPLBtn",
    ],
  
  }
</script>

